module.exports = __webpack_public_path__ + "img/search-dates.076b4d73.png";